import { Button, ButtonRow } from '@ksyos/design-system';
import { getSelectedLanguage } from '@frontend/translate';

interface AccountRequestDetailsEditingButtonsProps {
    onCancel: () => void;
    onSave: () => void;
}

export function AccountRequestEditingButtons(props: Readonly<AccountRequestDetailsEditingButtonsProps>) {
    const language = getSelectedLanguage();

    return (
        <ButtonRow
            justify="right"
            sx={{ paddingTop: '2.5rem' }}
        >
            <>
                <Button
                    onClick={props.onCancel}
                    variant="outline"
                >
                    {language.common.cancel}
                </Button>
                <Button
                    onClick={props.onSave}
                    variant="solid"
                >
                    {language.common.save}
                </Button>
            </>
        </ButtonRow>
    );
}
